import './Footer.css';

export default function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <p>Built with purpose. Powered by hype.</p>

        {/* <div className="league-logos">
          <img src="/logos/mlb.svg" alt="MLB logo" />
          <img src="/logos/nba.svg" alt="NBA logo" />
          <img src="/logos/nhl.svg" alt="NHL logo" />
        </div> */}

        <div className="footer-links">
          <a href="https://buymeacoffee.com/m42na" target="_blank" rel="noopener noreferrer">
            Buy Me a Coffee
          </a>
        </div>

        <p className="disclaimer">
          HypeScore is an independent project. All team and league marks are property of their respective owners.
        </p>
        <p className="copyright">
          © {new Date().getFullYear()} HypeScore. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
